import { styled, type SxProps } from '@mui/material';

export const Video = styled('video')<{ sx: SxProps }>({
  display: 'block',
  margin: 0,
  objectFit: 'cover',
  objectPosition: 'center',
  width: '100%',
  ...({ sx }) => sx,
});
